import "cropperjs/dist/cropper.css";
import Cropper from "react-cropper";
import React, { useState } from "react";
import CustomModal from "components/modals/CustomModal";
import { base64ToFile } from "utils/base64ToFile";
import { Button } from "components/form";
import { mediaFileHandler } from "utils/mediaHelper";
import { useTranslation } from "react-i18next";

const CoverImageCropper = ({
  imageModal,
  setImageModal,
  prevImage = "",
  error,
  idName,
  children,
  imageClassName,
  cropPicButtonLoader,
  updateUserPicHandler,
  ...rest
}) => {
  const [aspect] = useState(1);
  const [cropperImage, setCropperImage] = useState("");
  const [imageName, setImageName] = useState("");
  const [cropper, setCropper] = useState();

  const { t } = useTranslation();

  // File selection handler
  const onChange = (e) => {
    e.preventDefault();
    const imageFile = mediaFileHandler(e, "image");

    if (!imageFile || !(imageFile instanceof Blob)) {
      return;
    }

    // Read file and set cropper image
    const reader = new FileReader();
    reader.onload = () => {
      setCropperImage(reader.result);
      setImageModal(true);
    };
    reader.readAsDataURL(imageFile);
    setImageName(imageFile?.name);
  };

  // Get cropped image data
  const getCropData = () => {
    if (cropper) {
      const croppedData = cropper.getCroppedCanvas().toDataURL();
      const croppedFile = base64ToFile(croppedData, imageName);
      updateUserPicHandler(croppedFile);
      // setImageModal(false);
    }
  };

  // Cancel cropping
  const cancelHandler = () => {
    setImageModal(false);
    setCropperImage("");
    setImageName("");
  };

  return (
    <>
      <input
        type="file"
        id={idName}
        style={{ display: "none" }}
        onChange={onChange}
        accept="image/*"
      />
      {children}
      {/* Image Cropper Modal */}
      <CustomModal
        show={imageModal}
        handleClose={cancelHandler}
        className={"image_cropper"}
        size="lg"
      >
        <div className="crop_image">
          <Cropper
            className={imageClassName}
            initialAspectRatio={aspect}
            dragMode="move"
            preview=".img-preview"
            src={cropperImage}
            onInitialized={(instance) => setCropper(instance)}
            cropBoxResizable={true}
            aspectRatio={aspect}
            movable={false}
          />
        </div>
        <div className="button_wrap button_right">
          <Button className="light" onClick={cancelHandler}>
            {t("EDIT_PROFILE.cancel")}
          </Button>
          <Button onClick={getCropData} ref={cropPicButtonLoader}>
            {t("EDIT_PROFILE.crop")}
          </Button>
        </div>
      </CustomModal>
    </>
  );
};

export default CoverImageCropper;
